import { render, staticRenderFns } from "./ModalRegras.vue?vue&type=template&id=4c28e25a"
import script from "./ModalRegras.vue?vue&type=script&lang=js"
export * from "./ModalRegras.vue?vue&type=script&lang=js"
import style0 from "./ModalRegras.vue?vue&type=style&index=0&id=4c28e25a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports